/*!
 * 
 *   @bornfight/gocart v1.0.9
 *   
 * 
 *   Copyright (c) Bornfight (https://www.bornfight.com/)
 * 
 *   This source code is licensed under the MIT license found in the
 *   LICENSE file in the root directory of this source tree.
 *	Add Multiple Triggers
 *   
 */


class GoCart {

    constructor(options) {

        const defaults = {
            cartModalFail: '.js-go-cart-modal-fail',
            cartModalFailClose: '.js-go-cart-modal-fail-close',
            cartModal: '.js-go-cart-modal',
            cartModalClose: '.js-go-cart-modal-close',
            cartModalContent: '.js-go-cart-modal-content',
            cartModalItems: '.go-cart-item__single',
            cartDrawer: '.js-go-cart-drawer',
            cartDrawerContent: '.js-go-cart-drawer-content',
            cartDrawerSubTotal: '.js-go-cart-drawer-subtotal',
            cartDrawerFooter: '.js-go-cart-drawer-footer',
            cartDrawerClose: '.js-go-cart-drawer-close',
            cartMiniCart: '.js-go-cart-mini-cart',
            cartMiniCartContent: '.js-go-cart-mini-cart-content',
            cartMiniCartSubTotal: '.js-go-cart-mini-cart-subtotal',
            cartMiniCartFooter: '.js-go-cart-mini-cart-footer',
            cartTrigger: '.js-go-cart-trigger',
            cartOverlay: '.js-go-cart-overlay',
            cartCount: '.js-go-cart-counter',
            addToCart: '.js-go-cart-add-to-cart',
            removeFromCart: '.js-go-cart-remove-from-cart',
            removeFromCartNoDot: 'js-go-cart-remove-from-cart',
            itemQuantity: '.js-go-cart-quantity',
            itemQuantityPlus: '.js-go-cart-quantity-plus',
            itemQuantityMinus: '.js-go-cart-quantity-minus',
            cartMode: 'drawer',
            drawerDirection: 'right',
            displayModal: false,
            // eslint-disable-next-line no-template-curly-in-string
            moneyFormat: window.moneyFormat,
            labelAddedToCart: 'was added to your cart.',
            labelCartIsEmpty: 'Your Cart is currently empty!',
            labelQuantity: 'Quantity:',
            labelRemove: 'Remove',
            hiddenItemTag: 'hidden-product',
            cartDrawerHeaderCounter: '.go-cart-drawer__header_counter',
            cartFreeShippingAmount: '.go-cart-drawer__shipping-message',
            cartDiscountBar: '.go-cart--discount-bar',
            cartDiscountMessage: '.go-cart--discount-message',
            cartDiscountWrapper: '.go-cart--discount',
            cartShippingFill: '.go-cart-drawer__shipping-fill'
        };

        this.defaults = Object.assign({}, defaults, options);

        this.cartModalFail = document.querySelector(this.defaults.cartModalFail);
        this.cartShippingFill = document.querySelector(this.defaults.cartShippingFill);
        this.cartFreeShippingAmount = document.querySelector(this.defaults.cartFreeShippingAmount);
        this.cartModalFailClose = document.querySelector(this.defaults.cartModalFailClose);
        this.cartModal = document.querySelector(this.defaults.cartModal);
        this.cartModalClose = document.querySelectorAll(this.defaults.cartModalClose);
        this.cartModalContent = document.querySelector(this.defaults.cartModalContent);
        this.cartDrawer = document.querySelector(this.defaults.cartDrawer);
        this.cartDrawerContent = document.querySelector(this.defaults.cartDrawerContent);
        this.cartDrawerSubTotal = document.querySelector(this.defaults.cartDrawerSubTotal);
        this.cartDrawerFooter = document.querySelector(this.defaults.cartDrawerFooter);
        this.cartDrawerClose = document.querySelector(this.defaults.cartDrawerClose);
        this.cartMiniCart = document.querySelector(this.defaults.cartMiniCart);
        this.cartMiniCartContent = document.querySelector(this.defaults.cartMiniCartContent);
        this.cartMiniCartSubTotal = document.querySelector(this.defaults.cartMiniCartSubTotal);
        this.cartMiniCartFooter = document.querySelector(this.defaults.cartMiniCartFooter);
        this.cartTrigger = document.querySelectorAll(this.defaults.cartTrigger);
        this.cartOverlay = document.querySelector(this.defaults.cartOverlay);
        // this.cartCount = document.querySelector(this.defaults.cartCount);
        this.cartCount = document.querySelectorAll(this.defaults.cartCount);
        this.addToCart = document.querySelectorAll(this.defaults.addToCart);
        this.removeFromCart = this.defaults.removeFromCart;
        this.removeFromCartNoDot = this.defaults.removeFromCartNoDot;
        this.itemQuantity = this.defaults.itemQuantity;
        this.itemQuantityPlus = this.defaults.itemQuantityPlus;
        this.itemQuantityMinus = this.defaults.itemQuantityMinus;
        this.cartMode = this.defaults.cartMode;
        this.drawerDirection = this.defaults.drawerDirection;
        this.displayModal = this.defaults.displayModal;
        this.moneyFormat = this.defaults.moneyFormat;
        this.labelAddedToCart = this.defaults.labelAddedToCart;
        this.labelCartIsEmpty = this.defaults.labelCartIsEmpty;
        this.labelQuantity = this.defaults.labelQuantity;
        this.labelRemove = this.defaults.labelRemove;
        this.hiddenItemTag = this.defaults.hiddenItemTag;
        this.labelFreeShipping = this.defaults.labelFreeShipping;
        this.labelFreeShippingQualified = this.defaults.labelFreeShippingQualified;

        this.cartDrawerHeaderCounter = document.querySelector(defaults.cartDrawerHeaderCounter),
            this.cartDiscountBar = document.querySelector(defaults.cartDiscountBar),
            this.cartDiscountMessage = document.querySelector(defaults.cartDiscountMessage),
            this.cartDiscountWrapper = document.querySelector(defaults.cartDiscountWrapper);

        this.init();

    }

    get isDrawerMode() {
        return this.cartMode === 'drawer';
    }

    setupAtcButtons() {
        this.addToCart = document.querySelectorAll(this.defaults.addToCart);
        if (this.addToCart) {
            this.addToCart.forEach((item) => {
                item.addEventListener('click', (event) => {
                    event.preventDefault();
                    let form = item.parentNode;
                    while ('form' !== form.tagName.toLowerCase()) {
                        form = form.parentNode;
                    }
                    const formID = form.getAttribute('id');
                    this.addItemToCart(formID);
                });
            });
        }
    }

    init() {

        this.fetchCart();

        if (this.isDrawerMode) {
            this.setDrawerDirection();
        }

        /*
        document.addEventListener('click', (event) => {
            if (event.target.matches(this.defaults.addToCart)) {
                event.preventDefault();
                let item = event.target;
                let form = item.parentNode;
                while ('form' !== form.tagName.toLowerCase()) {
                    form = form.parentNode;
                }
                const formID = form.getAttribute('id');
                this.addItemToCart(formID);
            }
        }, false);
        */

        this.setupAtcButtons()

        this.cartTrigger.forEach((item) => {
            item.addEventListener('click', () => {
                if (this.isDrawerMode) {
                    this.openCartDrawer();
                } else {
                    this.openMiniCart();
                }
                this.openCartOverlay();
            });
        });

        this.cartOverlay.addEventListener('click', () => {
            this.closeFailModal();
            this.closeCartModal();
            if (this.isDrawerMode) {
                this.closeCartDrawer();
            } else {
                this.closeMiniCart();
            }
            this.closeCartOverlay();
        });

        if (this.isDrawerMode) {
            this.cartDrawerClose?.addEventListener('click', () => {
                this.closeCartDrawer();
                this.closeCartOverlay();
            });
        }

        if (this.displayModal) {
            this.cartModalClose.forEach((item) => {
                item.addEventListener('click', () => {
                    this.closeFailModal();
                    this.closeCartModal();
                    if (this.isDrawerMode) {
                        this.closeCartDrawer();
                    } else {
                        this.closeMiniCart();
                    }
                    this.closeCartOverlay();
                });
            });
        }

        this.cartModalFailClose.addEventListener('click', () => {
            this.closeFailModal();
            this.closeCartModal();
            if (this.isDrawerMode) {
                this.closeCartDrawer();
            } else {
                this.closeMiniCart();
            }
            this.closeCartOverlay();
        });

        this.setupRebuyListeners()
    }

    fetchCart(callback) {
        window.fetch('/cart?view=json', {
            credentials: 'same-origin',
            method: 'GET',
        })
            .then((response) => response.text())
            .then((cart) => { eval(cart); this.fetchHandler(window.cart, callback)})
            .catch((error) => {
                this.ajaxRequestFail();
                console.error(error)
                throw new Error(error);
            });
    }

    addItemToCart(formID) {
        const currentQuantity = document.querySelector(".js-qty__num")?.value || 1;
        const form = document.querySelector(`#${formID}`);
        const formData = serialize(form, { hash: true });
        formData.quantity = currentQuantity;
    
        window.fetch('/cart.js', {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .then((response) => response.json())
        .then((cart) => {
            const rechargeBundleInCart = cart.items.filter(item => {
                return item.product_type === "Recharge Bundle";
            });

            if (rechargeBundleInCart.length != 0 && (formData.type == rechargeBundleInCart[0].product_type) && formData.selling_plan) {
                this.showRechargeModal();
                return null; 
            }

            return window.fetch('/cart/add.js', {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
        })
        .then((response) => {
            if (!response) return null;
            return response.json();
        })
        .then((product) => {
            if (!product) return;

            this.addItemToCartHandler(product);
            return fetch('/cart.js');
        })
        .then((response) => {
            if (!response) return;
            return response.json();
        })
        .catch((error) => {
            console.error(error);
            this.ajaxRequestFail();
        });
    }
    
     showRechargeModal() {
        const modal = document.getElementById('subscription-modal');
        if (modal) {
          modal.style.display = 'flex';
          document.body.style.overflow = 'hidden';
        }
      }
            
    removeItem(line) {
        const quantity = 0;
        window.fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({quantity, line}),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => response.json())
            .then(() => this.fetchCart())
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    changeItemQuantity(line, quantity) {
        window.fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({quantity, line}),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => response.json())
            .then(() => this.fetchCart())
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    cartItemCount(cart) {
        this.cartCount.innerHTML = cart.item_count;
        this.cartDrawerHeaderCounter.innerHTML = ` ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`;
    }

    discountBar(cart) {
        this.renderDiscountBar(cart.total_price / 100);
    }

    renderDiscountBar(currentCartTotal) {
        const freeShippingThreshold = this.cartFreeShippingAmount.getAttribute('data-free-shipping-amount')
        const remaining = (freeShippingThreshold * 100) - (currentCartTotal * 100);

        this.cartShippingFill.dataset.trigger_amount = freeShippingThreshold * 100;
        this.cartShippingFill.dataset.subtotal = currentCartTotal;
        this.cartShippingFill.dataset.remaining = remaining;


        if (currentCartTotal < freeShippingThreshold) {
            this.cartShippingFill.style.setProperty("--bar-width", `${currentCartTotal}%`);
            this.cartDiscountMessage.innerHTML = this.labelFreeShipping.replace("XX", formatMoney(remaining, this.moneyFormat))
            // this.cartDiscountMessage.innerHTML = `You are&nbsp;<span>${formatMoney(remaining, this.moneyFormat)}</span>&nbsp;away from Free Shipping!`;

        } else {
            this.cartShippingFill.style.setProperty("--bar-width", "100%");
            this.cartDiscountMessage.innerHTML = this.labelFreeShippingQualified;
        }
    }

    fetchAndOpenCart() {
        this.fetchCart(() => {
            if (this.isDrawerMode) {
                this.openCartDrawer();
            } else {
                this.openMiniCart();
            }
            this.openCartOverlay();
        });
    }

    fetchAndOpenModal(product) {
        this.fetchCart(() => {
            this.renderCartModal(product);
            this.openCartModal();
            this.openCartOverlay();
        });
    }

    fetchHandler(cart, callback) {
        this.cartItemCount(cart);
        this.discountBar(cart)
        if (this.isDrawerMode) {
            if (cart.item_count === 0) {
                this.renderBlankCartDrawer();
                this.cartDrawerFooter.classList.add('is-invisible');
            } else {
                this.renderDrawerCart(cart);
                this.cartDrawerFooter.classList.remove('is-invisible');
                if ((typeof callback) === 'function') {
                    callback(cart);
                }
            }
        } else if (cart.item_count === 0) {
            this.renderBlankMiniCart();
            this.cartMiniCartFooter.classList.add('is-invisible');
        } else {
            this.renderMiniCart(cart);
            this.cartMiniCartFooter.classList.remove('is-invisible');
            if ((typeof callback) === 'function') {
                callback(cart);
            }
        }
    }

    addItemToCartHandler(product) {
        return this.displayModal ? this.fetchAndOpenModal(product) : this.fetchAndOpenCart();
    }

    ajaxRequestFail() {
        this.openFailModal();
        this.openCartOverlay();
    }

    renderCartModal(product) {
        this.clearCartModal();
        let productVariant = product.variant_title;
        if (productVariant === null) {
            productVariant = '';
        } else {
            productVariant = `(${productVariant})`;
        }
        const cartSingleProduct = `
          <div class="go-cart-modal-item">
            <div class="go-cart-item__image" style="background-image: url(${product.image});"></div>
            <div class="go-cart-item__info">
              ${product.product_title.includes(this.hiddenItemTag) ?
            `<p class="go-cart-item__title">${product.product_title} ${productVariant}</p>` :
            `<a href="${product.url}" class="go-cart-item__title">${product.product_title} ${productVariant}</a>`}
              ${this.labelAddedToCart}
            </div>
          </div>`;
        this.cartModalContent.innerHTML += cartSingleProduct;
    }

    toTitleCase(str) {
        return str.replace(/\w\S*/g, (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
    }

    renderDrawerCart(cart) {
        this.clearCartDrawer();
        this.discountBar(cart)

        cart.items.forEach((item, index) => {
            let itemVariant = item.variant_title || '';
            const hasSubscription = item.product?.selling_plan_groups?.length > 0;
            const sellingPlanGroups = item.product?.selling_plan_groups || [];
            const currentSellingPlanId = item.selling_plan_allocation?.selling_plan.id || '';

            const subscriptionWidget = hasSubscription ? `
            <div class="go-cart-item__subscription-widget">
                <select class="subscription-selector" data-line="${Number(index + 1)}" data-variant-id="${item.variant_id}">
                    ${item.product_tags?.includes('recharge-bundle') ? '' : `
                        <option value="" ${!currentSellingPlanId ? 'selected' : ''}>
                            One-time purchase
                        </option>
                    `}
                    ${sellingPlanGroups.map(group =>
                    group.selling_plans.map(plan => `
                        <option value="${plan.id}"
                            ${currentSellingPlanId === plan.id ? 'selected' : ''}
                            data-price="${plan.price_adjustments[0].price}"
                        >
                            ${plan.name}
                        </option>
                    `).join('')
            ).join('')}
                </select>
            </div>
        ` : '';

        const cartSingleProduct = `
            <div class="go-cart-item__single" data-line="${Number(index + 1)}">
                <div class="go-cart-item__info-wrapper">
                    ${item.product_tags?.includes('recharge-bundle') ? 
                    `<div class="go-cart-item__image"><img src="${item.image}"></div>` :
                    `<a href="${item.url}" class="go-cart-item__image"><img src="${item.image}"></a>`}
                    <div class="go-cart-item__info">
                        ${(item.product_tags?.includes('recharge-bundle') || item.product_tags?.includes(this.hiddenItemTag)) ?
                        `<p class="go-cart-item__title">${this.toTitleCase(item.product_title)}</p>` :
                        `<a href="${item.url}" class="go-cart-item__title">${this.toTitleCase(item.product_title)}</a>`}
                        ${(item.product_tags?.includes('recharge-bundle') || item.product_title.includes("GIFT CARD")) ? "" : `<div class="go-cart-item__variant body1">${itemVariant}</div>`}
                        ${subscriptionWidget}
                        
                        <div class="go-cart-price-qty">
                        ${item.product_tags?.includes('recharge-bundle') ? "" : `<div class="go-cart-item__quantity">
                                ${item.product_tags?.includes('recharge-bundle') ? "" :
                                    `<span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>`}
                                <input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" value="${item.quantity}" disabled>
                                ${item.product_tags?.includes('recharge-bundle') ? "" :
                                    `<span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>`}
                            </div>`}
                            <a class="go-cart-item__remove h6 ${this.removeFromCartNoDot}">Remove</a>
                        </div>
                    </div>

                        <div class="price-container">
                            ${item.final_price !== item.original_price ? `
                                <div class="go-cart-item__price compare-at">${formatMoney(item.original_price, this.moneyFormat)}</div>
                                <div class="go-cart-item__price">${formatMoney(item.final_price, this.moneyFormat)}</div>
                            ` : `
                                <div class="go-cart-item__price">${formatMoney(item.original_price, this.moneyFormat)}</div>
                            `}
                        </div>
                    
                </div>
            </div>`;

            this.cartDrawerContent.innerHTML += cartSingleProduct;

            if (hasSubscription) {
                const subscriptionSelectors = this.cartDrawerContent.querySelectorAll('.subscription-selector');
                subscriptionSelectors.forEach(selector => {
                    const newSelector = selector.cloneNode(true);
                    selector.parentNode.replaceChild(newSelector, selector);
                    newSelector.addEventListener('change', async (event) => {
                    const line = event.target.dataset.line;
                    const sellingPlanId = event.target.value;

                    try {
                        const updateResponse = await fetch('/cart/change.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                line,
                                properties: {},
                                selling_plan: sellingPlanId || null
                            })
                        });

                        if (!updateResponse.ok) throw new Error('Failed to update subscription plan');

                        await this.fetchCart();
                    } catch (error) {
                        console.error('Error updating subscription:', error);
                        subscriptionSelector.value = currentSellingPlanId;
                    }
                });
            })}
        });
        this.cartDrawerSubTotal.innerHTML = formatMoney(cart.total_price, this.moneyFormat);
        this.cartDrawerSubTotal.parentNode.classList.remove('is-invisible');
        this.setupCartItemListeners();
    }

    renderMiniCart(cart) {
        this.clearMiniCart();
        cart.items.forEach((item, index) => {
            let itemVariant = item.variant_title;
            if (itemVariant === null) {
                itemVariant = '';
            }
            const cartSingleProduct = `
              <div class="go-cart-item__single" data-line="${Number(index + 1)}">
                <div class="go-cart-item__info-wrapper">
                    <div class="go-cart-item__image" style="background-image: url(${item.image});"></div>
                    <div class="go-cart-item__info">
                        ${item.product_tags.includes(this.hiddenItemTag) ?
                `<p class="go-cart-item__title h3">${item.product_title}</p>` :
                `<a href="${item.url}" class="go-cart-item__title h3">${item.product_title}</a>`}
                        <div class="go-cart-item__variant">${itemVariant}</div>
                        <div class="go-cart-item__quantity">
                          ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-minus"><svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="14.3852" cy="13.8852" r="13.145" stroke="black"/><path d="M18.0589 14.5347L18.0584 14.5332L18.0589 14.5337L17.8326 13.8853L10.3906 13.8853L10.617 14.5352L18.0589 14.5347Z" fill="black"/></svg></span>`}
                          <input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" value="${item.quantity}" disabled>
                          ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-plus"><svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="14.3852" cy="13.8852" r="13.145" stroke="black"/><path d="M18.2191 14.5347L18.2185 14.5332L18.2191 14.5337L17.9927 13.8853L10.5508 13.8853L10.7771 14.5352L18.2191 14.5347Z" fill="black"/><path d="M14.061 18.0443L14.0625 18.0437L14.062 18.0443L14.7104 17.8179L14.7104 10.376L14.0605 10.6023L14.061 18.0443Z" fill="black"/></svg></span>`}
                        </div>
                    </div>
                </div>
                <div class="go-cart-item__price">${formatMoney(item.line_price, this.moneyFormat)}</div>
                <a class="go-cart-item__remove ${this.removeFromCartNoDot}">${this.labelRemove}</a>
              </div>`;
            this.cartMiniCartContent.innerHTML += cartSingleProduct;
        });
        this.cartMiniCartSubTotal.innerHTML = formatMoney(cart.total_price, this.moneyFormat);
        this.cartMiniCartSubTotal.parentNode.classList.remove('is-invisible');
        const removeFromCart = document.querySelectorAll(this.removeFromCart);
        removeFromCart.forEach((item) => {
            item.addEventListener('click', () => {
                GoCart.removeItemAnimation(item.parentNode);
                const line = item.parentNode.getAttribute('data-line');
                this.removeItem(line);
            });
        });
        const itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus);
        itemQuantityPlus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) + 1;
                this.changeItemQuantity(line, quantity);
            });
        });
        const itemQuantityMinus = document.querySelectorAll(this.itemQuantityMinus);
        itemQuantityMinus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) - 1;
                this.changeItemQuantity(line, quantity);
                if (Number((item.parentNode.querySelector(this.itemQuantity).value - 1)) === 0) {
                    GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode.parentNode.parentNode);
                }
            });
        });
    }

    setupCartItemListeners() {
        const removeFromCart = document.querySelectorAll(this.removeFromCart);
        removeFromCart.forEach((item) => {
            item.addEventListener('click', () => {
                const parent = item.parentNode.parentNode.parentNode.parentNode
                GoCart.removeItemAnimation(parent);
                const line = parent.getAttribute('data-line');
                this.removeItem(line);
            });
        });
        const itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus);
        itemQuantityPlus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) + 1;
                this.changeItemQuantity(line, quantity);
            });
        });
        const itemQuantityMinus = document.querySelectorAll(this.itemQuantityMinus);
        itemQuantityMinus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) - 1;
                this.changeItemQuantity(line, quantity);
                if (Number((item.parentNode.querySelector(this.itemQuantity).value - 1)) === 0) {
                    GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode.parentNode.parentNode);
                }
            });
        });
    }

    renderBlankCartDrawer() {
        this.cartDrawerSubTotal.parentNode.classList.add('is-invisible');
        this.clearCartDrawer();
        this.cartDrawerContent.innerHTML = `<div class="go-cart__empty">${this.labelCartIsEmpty}<a class="button cta cta-gig-primary" href="/collections/all"><span>SHOP ALL</span></a></div>`;
    }

    renderBlankMiniCart() {
        this.cartMiniCartSubTotal.parentNode.classList.add('is-invisible');
        this.clearMiniCart();
        this.cartMiniCartContent.innerHTML = `<div class="go-cart__empty">${this.labelCartIsEmpty}<a class="button cta cta-gig-primary" href="/collections/all"><span>SHOP ALL</span></a></div>`;
    }

    reloadAjaxContent() {
        this.fetchAndOpenCart();
    }

    clearCartDrawer() {
        this.cartDrawerContent.innerHTML = '';
    }

    clearMiniCart() {
        this.cartMiniCartContent.innerHTML = '';
    }

    clearCartModal() {
        this.cartModalContent.innerHTML = '';
    }

    openCartDrawer() {
        this.cartDrawer.classList.add('is-open');
        document.querySelector('body').classList.add('drawer-open');
    }

    closeCartDrawer() {
        this.cartDrawer.classList.remove('is-open');
        document.querySelector('body').classList.remove('drawer-open');
    }

    openMiniCart() {
        this.cartMiniCart.classList.add('is-open');
    }

    closeMiniCart() {
        this.cartMiniCart.classList.remove('is-open');
    }

    openFailModal() {
        this.cartModalFail.classList.add('is-open');
    }

    closeFailModal() {
        this.cartModalFail.classList.remove('is-open');
    }

    openCartModal() {
        this.cartModal.classList.add('is-open');
    }

    closeCartModal() {
        this.cartModal.classList.remove('is-open');
    }

    openCartOverlay() {
        this.cartOverlay.classList.add('is-open');
    }

    closeCartOverlay() {
        this.cartOverlay.classList.remove('is-open');
    }

    static removeItemAnimation(item) {
        item.classList.add('is-invisible');
    }

    setDrawerDirection() {
        this.cartDrawer.classList.add(`go-cart__drawer--${this.drawerDirection}`);
    }

    setupRebuyListeners() {
        document.addEventListener('rebuy:cart.change', async (event) => {
            let cartData = event.detail.cart.cart;
            for (let item of cartData.items) {
                let productData = await fetch(`/products/${item.handle}.js`).then(res => res.json());
                item.product = productData
                item.product_tags = productData.tags
            }
            this.fetchHandler(cartData);
            const itemCount = event.detail.cart.itemCount()
            const cartHeaderIconItemCount = document.querySelectorAll(".js-go-cart-counter")
            cartHeaderIconItemCount.forEach(v => {
                v.innerHTML = `${itemCount}`
            })
        });
    }
}

//export default GoCart;
